import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { WizardComponent } from "../../../../Shared/Process/WizardComponent";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { ConvertToFlexiAction } from "./Actions/ConvertToFlexiActions";
import { Review } from "./Components/Review";
import { SelectArrangement } from "./Components/SelectArrangement";
import { convertToFlexiStepperName } from "./Resource/Content";
import { CappedPensionArrangementsFlexiConversionAvailabilitiesStore, ClientAccountStore as CappedToFlexiClientAccountStore, ConvertToFlexiInstructionStore, PersonalDetailsStore } from "./Store/Variable";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { AccountRoleStore, ClientAccountStore as CommonClientAccountStore } from "../../../Stroes/Variable";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { AccountContextWizardComponent, IAccountContextWizardComponentState } from "../../../../Shared/Process/AccountContextWizardComponent";

type ConvertCappedToFlexiData = {
    instruction: any;
    arrangementDetails: any;
    PersonalDetails: any;
    ClientAccount: any;
}

interface ConvertCappedToFlexiWizardState extends IAccountContextWizardComponentState {
    data: ConvertCappedToFlexiData
}

export class ConvertCappedToFlexiWizard extends AccountContextWizardComponent<ConvertCappedToFlexiWizardState> {

    initState() {
        this.state = {
            errorMsg: [],
            isShowErrorMsg: false,
            data: {
                arrangementDetails: null,
                instruction: null,
                PersonalDetails: null
            } as ConvertCappedToFlexiData,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null
        };
    }

    constructor(props: any) {
        super(props);
        this.subscribeToStore(ConvertToFlexiInstructionStore, () => this.onInstructionStoreChange());
        this.subscribeToStore(CappedPensionArrangementsFlexiConversionAvailabilitiesStore, () => this.onAvailabilitiesStoreChange());
        this.subscribeToStore(PersonalDetailsStore, () => this.onPersonalDetailsStoreChange());
        this.subscribeToStore(CappedToFlexiClientAccountStore, () => this.onCappedToFlexiClientAccountStoreChange());
    }

    private onInstructionStoreChange() {
        let data = this.state.data;
        if (ConvertToFlexiInstructionStore.getActionType() == ActionType.Success) {
            const instruction = ConvertToFlexiInstructionStore.getData();
            data.instruction = instruction;

            this.setState({
                isLoading: false,
                data: data
            });
        }
    }

    private onCappedToFlexiClientAccountStoreChange() {
        let data = this.state.data;
        if (CappedToFlexiClientAccountStore.getActionType() == ActionType.Success) {
            const clientAccount  = CappedToFlexiClientAccountStore.getData();
            data.ClientAccount = clientAccount;

            this.setState({
                isLoading: false,
                data: data
            });
        }
    }

    private onPersonalDetailsStoreChange() {
        let data = this.state.data;
        if (PersonalDetailsStore.getActionType() == ActionType.Success) {
            const personalDetails  = PersonalDetailsStore.getData();
            data.PersonalDetails = personalDetails;

            this.setState({
                isLoading: false,
                data: data
            });
        }
    }

    private onAvailabilitiesStoreChange() {
        let data = this.state.data;
        if (CappedPensionArrangementsFlexiConversionAvailabilitiesStore.getActionType() == ActionType.Success) {
            const arrangementDetails  = CappedPensionArrangementsFlexiConversionAvailabilitiesStore.getData();
            data.arrangementDetails = arrangementDetails;

            this.setState({
                isLoading: false,
                data: data
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({
            isLoading: true
        });
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const hierarchyId = getQueryParameters()["hierarchyid"];
        const instructionId = getQueryParameters()["id"];
        ConvertToFlexiAction.getArrangementDetails(subAccountHierarchyId);
        ConvertToFlexiAction.getInstruction(instructionId, subAccountHierarchyId);
        ConvertToFlexiAction.getPersonalDetailsByHierarchyId(hierarchyId);
        ConvertToFlexiAction.getClientAccountByHierarchyId(hierarchyId);
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        if (from == stepLength - 1) {return this.onExit();}
        if (!params["id"]) {params["id"] = this.state.data.instruction.Id;}

        ConvertToFlexiAction.saveInstruction(this.state.data.instruction, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = CommonClientAccountStore.getClientAccountInfo();
        console.log(accountRoles, clientAccount)
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        ConvertToFlexiAction.submitInstruction(this.state.data.instruction, (result) => {
            this.setState({ isSubmitting: false });
            if (!result.SubmissionSucceed) {
                this.setState({
                    active: true,
                    errorMsg: [`There was an error when processing`],
                });
            }
        });
    }

    setStepperConfig() {
        const clAccountId = getQueryParameters()["claccountid"];
        const { data } = this.state;

        this.stepperConfig = [
            {
                title: convertToFlexiStepperName.selectArrangement,
                url: Urls.get().ConvertToFlexiSelectArrangement,
                path: Contents.URLMap.selectArrangement,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <SelectArrangement {...this.getStepProps(0)}/>,
            },
            {
                title: convertToFlexiStepperName.review,
                url: Urls.get().ConvertToFlexiReview,
                path: Contents.URLMap.review,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
                needPrint: true,
                component: (
                    <Review
                        {...this.getStepProps(1)}
                        onClearError={() => this.setState({ errorMsg: [], isShowErrorMsg: false })}
                    ></Review>
                ),
            },
            {
                title: convertToFlexiStepperName.confirmation,
                url: Urls.get().ConvertToFlexiConfirmation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <Confirmation
                        onExit={() => {
                            this.state.errorMsg.length > 0
                                ? Navigator.navigateToAndPreserveQueryParameters(Urls.get().ConvertToFlexiReview)
                                : this.onExit();
                        }}
                        buttonLabel={this.state.errorMsg.length > 0 ? "Previous" : "Back to dashboard"}
                        errorMsg={this.state.errorMsg[0]}
                        successMessage={`We've received your instruction for ${data?.PersonalDetails?.GivenName}  ${data?.PersonalDetails?.FamilyName} (${clAccountId})
                        .`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Convert Capped to Flexible Drawdown";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${this.state?.data?.PersonalDetails?.GivenName}  ${this.state?.data?.PersonalDetails?.FamilyName}`,
            splitHeaderSub: `${this.state?.data?.ClientAccount?.HeadClAccountId}`
        }
        return processProps;
    }
}
